// src/pages/ReportsPage.js
import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import StandardReports from "../components/Reports/StandardReports";
import CustomReportBuilder from "../components/Reports/CustomReportBuilder";
import "../components/Reports/Reports.css";

const ReportsPage = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className="p-3">
            <div className="mb-3">
                <h2 className="m-0 font-semibold text-900" style={{ fontSize: "1.4rem" }}>
                    <i className="pi pi-chart-bar mr-2 text-primary" />
                    Reports
                </h2>
                <p className="text-600 mt-1 mb-0 text-sm">
                    Analytics, insights, and custom data exports for your pharmacy.
                </p>
            </div>

            <TabView
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
                className="reports-tabview"
            >
                <TabPanel header="Standard Reports" leftIcon="pi pi-chart-line mr-2">
                    <StandardReports />
                </TabPanel>
                <TabPanel header="Custom Report Builder" leftIcon="pi pi-sliders-h mr-2">
                    <CustomReportBuilder />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default ReportsPage;